//
// Generated class IntegratorConfig
//

/// <reference path="IntegratorConfig_ManagedObject.ts" />

enum IntegratorConfigType
{
    None          = 0,
    SemiAutomatic = 1,
    Automatic     = 2
}

class IntegratorConfig extends IntegratorConfig_ManagedObject
{

}
